import React from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'
import { take } from 'lodash'

import {
  LinkComponent,
  PopoverTextBox,
} from '../../../../../components/generic'

export default function PRNPopoverLogs(props) {
  const { logs } = props

  const displayedLogs = logs.length >= 10 ? take(logs, 3) : logs

  return (
    <div style={styles.textBoxContainer}>
      {displayedLogs.map((log, index) => {
        const logStyle = index !== 0 ? styles.log : null

        return (
          <div key={log.id} style={logStyle}>
            <LinkComponent to={`/logs/${log.id}`}>
              <PopoverTextBox
                carerName={log?.loggedBy.name}
                details={log.description}
                timestamp={dayjs(log.timeLogged).format('DD-MM-YYYY • HH:mm')}
                title={log.title}
              />
            </LinkComponent>
          </div>
        )
      })}
      {logs.length >= 10 && (
        <div style={styles.log}>
          <LinkComponent
            to={`/residents/${logs[0].resident}/emar/${logs[0].emarResidentMedication}/chart`}
          >
            <PopoverTextBox title={`+ ${logs.length - 3} logs`} />
          </LinkComponent>
        </div>
      )}
    </div>
  )
}

PRNPopoverLogs.propTypes = {
  logs: PropTypes.array.isRequired,
}

const styles = {
  log: {
    marginTop: 8,
  },
  textBoxContainer: {
    margin: '-12px -16px',
    width: 285,
  },
}
